import assetPath from '/opt/actions-runner/_work/crate/crate/packages/dream-machine/search-bar/src/components/assets/Background_04_7x2_a.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')